// extracted by mini-css-extract-plugin
export default {"voucher":"buyVoucherBtn_voucher__16bMI","leftImage":"buyVoucherBtn_leftImage__7Lo+L","kakao":"buyVoucherBtn_kakao__V3CW3","counselor":"buyVoucherBtn_counselor__fKUSU"};